import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TrackingOp from "../../components/TrackingOp";
import WrapperMessage from "./WrapperMessage";
import { messageActions } from "./reducer";
import styles from './style.module.scss';

const MessagePage = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        return () => {
            dispatch(messageActions.setNewConversationType());
        }
    })

    return <div className={[styles.wrapper, 'm-header bgPage'].join(' ')}>
        <WrapperMessage />
        <TrackingOp />
    </div>;
}


export default MessagePage;
